export const branding = { name: "PIN Clube", headerBackground: "#94532A", headerText: "#FFFFFF", headerMuted: "#FFE8D4", navy: "#0B2D66", orange: "#FF7E00" };
